<template>
  <Audio :id="uniqueId" class="audioClip" :autoplay="autoplayString" hidden :loop="loop">
    <source :src="AudioClipSource" type="Audio/mpeg" />
  </Audio>
</template>

<script lang="ts">
import Vue from "vue";
import { v4 as uuidv4 } from "uuid";

export default Vue.extend({
  name: "AudioClip",
  props: {
    id: String,
    loop: Boolean,
    autoplay: Boolean,
    isFadingOut: Boolean,
    overrideVolume: Number,
  },
  data() {
    return {
      uniqueId: uuidv4(),
      alreadyFadingOut: false,
      volume: this.overrideVolume ? this.overrideVolume : 0.25,
    };
  },
  watch: {
    isFadingOut(value: boolean) {
      if (value == false || this.alreadyFadingOut) {
        return;
      }
      this.alreadyFadingOut = true;
      requestAnimationFrame(this.fade);
    },
  },
  methods: {
    fade(delta: number) {

      this.volume -= delta / 5000;
      if (this.volume < 0) {
        this.volume = 0;
      }

      const vid = document.getElementById(this.uniqueId) as HTMLAudioElement;
      vid.volume = this.volume;

      if (this.volume > 0) {
        //Not finished yet
        requestAnimationFrame(this.fade);
      }
      else {
        vid.muted = true;
      }

    }
  },
  mounted() {
    const vid = document.getElementById(this.uniqueId) as HTMLAudioElement;
    vid.volume = this.volume;
  },
  computed: {
    autoplayString: {
      cache: false,
      get(): string {
        return this.autoplay ? "autoplay" : "false";
      }
    },
    AudioClipSource: {
      cache: false,
      get(): string {
        return process.env.BASE_URL + "audio/" + this.id + ".mp3";
      },
    },
  },
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less"></style>
